import Roller from './Roller';
import styles from './Counter.module.scss';
/**
 * The spacing appearance of a chunk of the counter
 */
type ChunkSize = 'monospaced' | 'normal' | 'micro';

interface ICounterProps {
    /**
     * The label which appears above the counter
     */
    label?: string;
    /**
     * Endpoint URL
     */
    url: string;
    /**
     * When using a graphic source for characters,
     * the path to said resource
     */
    charSrc?: string;
    /**
     * The width of groups chars
     * the comma in $1,000.00
     */
    className: string;
    groupSize?: ChunkSize;
    /**
     * The direction to merge if micro
     */
    groupMerge?: string | 'left' | 'right';
    /**
     * The width of decimal chars
     * the period in $1,000.00
     */
    decimalSize?: ChunkSize;
    /**
     * The direction to merge if micro
     */
    decimalMerge?: string | 'left' | 'right';
    /**
     * The width of literal chars
     * commonly the space before the dollar sign in CAD's 1 000,00 $
     */
    literalSize?: ChunkSize;
    /**
     * The width of currency chars
     * the dollar or euro in $1,000.00 or 1.000,00 €, respectively
     */
    currencySize?: ChunkSize;
    /**
     * The language the currency is formatted for
     */
    lang?: string;
    /**
     * The currency the input number is being formatted into
     */
    currency?: string;
    /**
     * Whether to use grouping separators on the displayed value
     * For example in USD $1000000 vs $1,000,000 where the comma
     * groups three digits.
     */
    useGrouping?: boolean;
}

const Counter: React.FC<ICounterProps> = ({
    label = '',
    url,
    charSrc,
    className,
    groupSize = 'micro',
    groupMerge = '',
    decimalSize = 'micro',
    decimalMerge = '',
    literalSize = 'normal',
    currencySize = 'monospaced',
    lang = 'en-US',
    currency = 'USD',
    useGrouping = true,
}) => {
    return (
        <div className={`${styles['counter-wrapper']}${' ' + className}`}>
            <div className={styles['roller-wrapper']}>
                <div className={styles['backing-wrapper']}>
                    <img
                        className={`${styles['backing-left']} backing-wrapper-left`}
                        src='animations/progressive-jackpot/img/backing-left-cap.svg'
                        alt='counter left background'
                    />
                    <img
                        className={`${styles['backing-center']} backing-wrapper-center`}
                        src='animations/progressive-jackpot/img/backing-center.svg'
                        alt='counter center background'
                    />
                    <img
                        className={`${styles['backing-right']} backing-wrapper-right`}
                        src='animations/progressive-jackpot/img/backing-right-cap.svg'
                        alt='counter right background'
                    />
                </div>
                <Roller
                    url={url}
                    label={label}
                    charSrc={charSrc}
                    decimalMerge={decimalMerge}
                    groupMerge={groupMerge}
                    currencySize={currencySize}
                    groupSize={groupSize}
                    decimalSize={decimalSize}
                    literalSize={literalSize}
                    lang={lang}
                    currency={currency}
                    useGrouping={useGrouping}></Roller>
            </div>
        </div>
    );
};

export default Counter;
